// 달 응답 — 입력 타입 + 위기/에러 응답.
// ★ AI 실패 시 예시 편지(프리셋) 폴백 금지 — 평문 에러로 라우팅(진짜 응답인 척 X). 위기 분기와 별개.

import type { Lang, MoonError, MoonResponse } from "./types";

export interface MoonInput {
  lang: Lang;
  text: string; // 고백 원문(세션 메모리 — 응답 뒤 폐기).
  now: Date;
}

export interface Moon {
  respond(input: MoonInput): Promise<MoonResponse>;
}

/** 기술적 실패 — 편지 없이 에러면으로 분기(평문 + 재시도). 더미 편지 금지. */
export function errorResponse(kind: MoonError): MoonResponse {
  return {
    crisis: false,
    error: kind,
    register: "weary",
    letter: "",
    oneLine: "",
    prophecy: { type: 1, text: "" },
  };
}

/** 위기 응답(편지·한 마디 비움 — 안전면으로 분기). 로컬 1차는 자기 위기만 잡으므로 self_crisis. */
export function crisisResponse(): MoonResponse {
  return {
    crisis: true,
    gate: "self_crisis",
    register: "heavy",
    letter: "",
    oneLine: "",
    prophecy: { type: 1, text: "" },
  };
}

// 엔드포인트 미설정(프리뷰/오프라인 dev)용 목 — 더미 편지 대신 에러면(실패는 실패로 보이게).
export const mockMoon: Moon = {
  async respond(): Promise<MoonResponse> {
    await new Promise((r) => setTimeout(r, 300));
    return errorResponse("unavailable");
  },
};
